import Briefcase from 'assets/images/icons/Briefcase.svg?react';
import { FormattedMessage } from 'react-intl';

const BankTransferNothingToShow = () => {
    return (
        <div className="px-16 py-6">
            <div className="flex flex-col items-center">
                <p className="text-body1 text-fg-secondary">
                    <FormattedMessage id="bank-transfers.nothing-to-show" />
                </p>
                <Briefcase />
            </div>
        </div>
    );
};

export default BankTransferNothingToShow;
